import React, { useMemo } from 'react';

import { Roles } from '@/common/constants';
import { StatusBlock } from '@/components/elements/StatusBlock';

interface Props {
  role?: Roles;
}

const UserAccessStatusCard: React.FC<Props> = ({ role }) => {
  const userAccessStatusCard = useMemo(() => {
    if (role === Roles.employee) {
      return <StatusBlock testId="user-verification-status-form_user-access" title="Full access" backgroundColor="success" />;
    }

    if (role === Roles.limitedAccess) {
      return <StatusBlock testId="user-verification-status-form_user-access" title="Limited access" backgroundColor="warning" />;
    }

    return <StatusBlock testId="user-verification-status-form_user-access" title="No access" backgroundColor="danger" />;
  }, [role]);

  return userAccessStatusCard;
};

export default UserAccessStatusCard;
